export default __webpack_public_path__ + "static/media/central_andes_1_12.52751297.JPG";